import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { ControlDeviceDto } from '@/types/dtos/player/request/control-device.dto.ts';
import { GET_PLAYERS_QUERY_KEY } from '@/state/queries/players/use-get-players';

export const useControlDeviceMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: ControlDeviceDto) => {
      const token = await getToken();
      return controlDevice(body, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_PLAYERS_QUERY_KEY] });
    },
  });
};

const controlDevice = async (body: ControlDeviceDto, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/player/control-device`;
  await sendJSONRequest({ url, method: METHOD.POST, body, token });
};
